import React from 'react';
import { Navigate } from 'react-router-dom';

// Lazy load components
const Parents = React.lazy(() => import('../pages/School/Parents/Parents'));
const NewParent = React.lazy(() => import('../pages/School/Parents/NewParent'));
const ParentView = React.lazy(() => import('../pages/School/Parents/ParentView'));
const EditParent = React.lazy(() => import('../pages/School/Parents/EditParent'));
const Students = React.lazy(() => import('../pages/School/Students/Students'));
const StudentView = React.lazy(() => import('../pages/School/Students/StudentView'));
const SchoolPayments = React.lazy(() => import('../pages/School/Payments/SchoolPayments'));
const SchoolCharges = React.lazy(() => import('../pages/School/Charges/SchoolCharges'));
const SchoolRecurringPayments = React.lazy(() => import('../pages/School/RecurringPayments/SchoolRecurringPayments'));
const SchoolRecurringCharges = React.lazy(() => import('../pages/School/RecurringCharges/SchoolRecurringCharges'));
const NewPayment = React.lazy(() => import('../pages/Payments/NewPayment'));
const NewPledge = React.lazy(() => import('../pages/Pledges/NewPledge'));
const PledgeDetail = React.lazy(() => import('../pages/Pledges/PledgeDetail'));
const RecurringPledgeDetail = React.lazy(() => import('../pages/Pledges/RecurringPledges/RecurringPledgeDetail'));
const RegistrationSettingsList = React.lazy(() => import('../pages/Registration/RegistrationSettingsList'));
const RegistrationActionChooser = React.lazy(() => import('../pages/Registration/RegistrationActionChooser'));
const ViewRegistrationsList = React.lazy(() => import('../pages/Registration/ViewRegistrationsList'));
const ViewRegistration = React.lazy(() => import('../pages/Registration/ViewRegistration'));
const RegisterForParent = React.lazy(() => import('../pages/Registration/RegisterForParent'));
const RegistrationMediaSetup = React.lazy(() => import('../pages/Registration/RegistrationMediaSetup'));
const ParentLoginSetup = React.lazy(() => import('../pages/ParentLogin/ParentLoginSetup'));
const MealPunchPage = React.lazy(() => import('../pages/School/MealPunch/MealPunchPage'));

export const getSchoolRoutes = (loggedIn, visibleTabs, location, loginRedirect = '/login') => [
  {
    path: '/parents-list',
    element: loggedIn && visibleTabs?.includes('School_Parents') 
      ? <Parents /> 
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'add-parent',
        element: loggedIn && visibleTabs?.includes('School_Parents')
          ? <NewParent />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'parent-view',
        element: loggedIn && visibleTabs?.includes('School_Parents')
          ? <ParentView />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'parent-edit',
        element: loggedIn && visibleTabs?.includes('School_Parents')
          ? <EditParent />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  },
  {
    path: '/students-list',
    element: loggedIn && visibleTabs?.includes('School_StudentList')
      ? <Students />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />
  },
  {
    path: '/registration',
    element: loggedIn && visibleTabs?.includes('School')
      ? <RegistrationSettingsList />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />
  },
  {
    path: '/registration/:parentLoginId/registrations/:parentId',
    element: loggedIn && visibleTabs?.includes('School')
      ? <ViewRegistration />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />
  },
  {
    path: '/registration/:parentLoginId/registrations',
    element: loggedIn && visibleTabs?.includes('School')
      ? <ViewRegistrationsList />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />
  },
  {
    path: '/registration/:parentLoginId/register-for-parent',
    element: loggedIn && visibleTabs?.includes('School')
      ? <RegisterForParent />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />
  },
  {
    path: '/registration/:parentLoginId/media',
    element: loggedIn && visibleTabs?.includes('School')
      ? <RegistrationMediaSetup />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />
  },
  {
    path: '/registration/:parentLoginId',
    element: loggedIn && visibleTabs?.includes('School')
      ? <RegistrationActionChooser />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />
  },
  {
    path: '/parent-login-setup/:parentLoginId',
    element: loggedIn && visibleTabs?.includes('School')
      ? <ParentLoginSetup />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />
  },
  {
    path: '/school-payments',
    element: loggedIn && visibleTabs?.includes('School_Payments')
      ? <SchoolPayments />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'new-payment',
        element: loggedIn && visibleTabs?.includes('School_Payments')
          ? <NewPayment isSchool={true} />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  },
  {
    path: '/school-charges',
    element: loggedIn && visibleTabs?.includes('School_Charges')
      ? <SchoolCharges />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'new-pledge',
        element: loggedIn && visibleTabs?.includes('School_Charges')
          ? <NewPledge isSchool={true} />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'pledge-details',
        element: loggedIn && visibleTabs?.includes('School_Charges')
          ? <PledgeDetail />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  },
  {
    path: '/school-recurring-payments',
    element: loggedIn && visibleTabs?.includes('SchoolRecurringPayment')
      ? <SchoolRecurringPayments />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'new-payment',
        element: loggedIn && visibleTabs?.includes('SchoolRecurringPayment')
          ? <NewPayment isSchool={true} />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  },
  {
    path: '/school-recurring-charges',
    element: loggedIn && visibleTabs?.includes('School_RecurringCharges')
      ? <SchoolRecurringCharges />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />,
    children: [
      {
        path: 'new-pledge',
        element: loggedIn && visibleTabs?.includes('School_RecurringCharges')
          ? <NewPledge isSchool={true} />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      },
      {
        path: 'pledge-details',
        element: loggedIn && visibleTabs?.includes('School_RecurringCharges')
          ? <RecurringPledgeDetail />
          : <Navigate to={loginRedirect} state={{ from: location }} replace />
      }
    ]
  },
  {
    path: '/meal-punch',
    element: loggedIn && visibleTabs?.includes('MealPunch')
      ? <MealPunchPage />
      : <Navigate to={loginRedirect} state={{ from: location }} replace />
  }
];

